import { Products } from "ProductConfig";
import { useEffect } from "react";
import { useLocation } from 'react-router-dom';

const DynamicPageTitle = ({ basePath }) => {
  const location = useLocation();

  useEffect(() => {
    let title = "Zecurit";

    Object.entries(Products).forEach(([key, value]) => {
      if (basePath.includes(`/${key}`)) {
        title = `Zecurit ${value}`;
      }
    });

    document.title = title;
  }, [location, basePath]);

  return null;
};

export default DynamicPageTitle;